var map = {
	"./icon_arrow_left.svg": "6de1",
	"./icon_arrow_right.svg": "d565",
	"./icon_calendar_month.svg": "6353",
	"./icon_check.svg": "e34e",
	"./icon_checkbox_checked.svg": "d3c9",
	"./icon_checkbox_unchecked.svg": "b183",
	"./icon_chevron_down.svg": "9723",
	"./icon_chevron_left.svg": "d2ad",
	"./icon_chevron_right.svg": "8012",
	"./icon_chevron_up.svg": "13c2",
	"./icon_circle_check.svg": "b3ec",
	"./icon_close.svg": "ea4e",
	"./icon_eye_off.svg": "60d2",
	"./icon_eye_on.svg": "1dd9",
	"./icon_help.svg": "a7f5",
	"./icon_home.svg": "7429",
	"./icon_logout.svg": "80ad",
	"./icon_menu_down.svg": "4540",
	"./icon_menu_up.svg": "d560",
	"./icon_mute.svg": "9671",
	"./icon_pause.svg": "b9ad",
	"./icon_play.svg": "4f38",
	"./icon_radio_button_checked.svg": "911d",
	"./icon_radio_button_unchecked.svg": "47bb",
	"./icon_restart.svg": "bda6",
	"./icon_settings.svg": "f125",
	"./icon_skip.svg": "fec1",
	"./icon_star.svg": "ae3c",
	"./icon_star_half.svg": "5746",
	"./icon_star_outline.svg": "685c",
	"./icon_stat_first.svg": "0d66",
	"./icon_stat_second.svg": "4418",
	"./icon_unmute.svg": "b625"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e85";